<img src="assets/icons/menu.png" style="transform: translateX(150px);">
<ul>
	<ng-container *ngFor="let item of MenuItems">
		<li *ngIf="item" [routerLinkActive]="'nav__linkItem--active'" class="nav__linkItem">
			<collab-comp-img-generator imageType="image" [imgUrl]="getUrl(item['icon'])" ></collab-comp-img-generator>
			<a class="nav-link" routerLink="{{item.path}}">{{item.label}} </a>
		</li>
	</ng-container>
</ul>
